<template>
    <div class="create">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="nav">经营区域决定了您能看到商品的区域，请如实填写哦～</div>
        <div class="content">
            <van-field
                v-model="companyName"
                type="text"
                required
                maxlength = '50'
                label="企业简称"
                placeholder="请输入您的企业名称或店铺名称"
            />
            <van-field
                v-model="addressName"
                type="text"
                required
                @click="onArea"
                maxlength = '11'
                label="经营区域"
                :readonly = 'true'
                right-icon="question-o"
                placeholder="请选择您的经营区域"
            />
            <van-field
                v-model="code"
                type="text"
                maxlength = '11'
                label="邀请码"
                placeholder="请输入商家邀请码"
            />
        </div>
        <div class="btn">
            <p @click="onSubmit"><van-button  color="#FF7A45" :round="true" type="default">确认创建</van-button></p>
            <p class="cancel" @click="onBack">取消</p>
        </div>
        <areaList ref="area" @onArea='onAreaData'></areaList>
    </div>
</template>
<script>
import Header from '../../common/header'
import areaList from '../common/area'
import { mapActions } from 'vuex'
import { Toast } from 'vant'
export default {
    name: 'join',
    components: {
        Header,
        areaList
    },
    data () {
        return {
            title: '创建企业',
            companyName: '',
            code: '',
            addressName: '',
            areaData: '',
            userInfo: ''
        }
    },
    methods: {
        ...mapActions(['createCompany', 'getUserInfoData']),
        onBack () {
            this.$router.go(-1)
        },
        onArea () {
            this.$refs.area.onShow()
        },
        async onSubmit () {
            if (!this.companyName) {
                Toast('请输入企业简称')
                return false
            }
            if (!this.addressName) {
                Toast('请选择经营区域')
                return false
            }
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            try {
                await this.createCompany({
                    companyName: this.companyName,
                    provinceId: this.areaData.provinceId,
                    provinceName: this.areaData.provinceName,
                    cityId: this.areaData.cityId,
                    cityName: this.areaData.cityName,
                    countryId: this.areaData.countryId,
                    countryName: this.areaData.countryName,
                    invitationCode: this.code,
                    createBy: this.userInfo.id
                }).then((data) => {
                    Toast({
                        message: '保存成功'
                    })
                    this.$router.push({ path: '/b2b/company/index' })
                })
            } catch (error) {
                // Toast.clear()
            }
        },
        onAreaData (data) {
            this.addressName = data.addressName
            this.areaData = data
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
}
</script>
<style lang="scss" scoped>
    .create{
        height: 100%;
        .nav{
            font-size: 26px;
            padding: 22px 32px;
            color: #FF7A45;
            background: #FFF2E8;
        }
        .content{
            background: #ffffff;
            padding-left: 32px;
            font-size: 28px;
        }
        .btn{
            padding: 48px 32px;
            .cancel{
                color: #666666;
                font-size: 28px;
                text-align: center;
                margin-top: 48px;
            }
        }
    }
    /deep/ .van-button--normal {
        width: 100%;
        height: 96px;
        line-height: 96px;
        font-size: 32px;
    }
    /deep/ .van-button--default{
        border: 2px solid rgb(255, 122, 69);
    }
    /deep/ .van-icon-question-o:before{
        content: "\F00A";
    }
    /deep/ .van-field__right-icon {
        margin: 0 20px;
    }
</style>